import Axios from "axios";
import {baseBackendRoute} from "../config/generals";
import {apiClient} from "@leap4/frontend"
export const ApiClient = apiClient;